
import React from 'react';

import { Dialog } from '../../../../base/dialog';
import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import LoadingComponent from '../../../../base/util/LoadingComponent';
import AbstractStartRecordingDialog, {
    mapStateToProps
} from '../AbstractStartRecordingDialog';
import StartRecordingDialogContent from '../StartRecordingDialogContent';
import { LOADING_INDICATOR } from '../styles';

import ErrorBoundary from './ErrorBoundary';


/**
 * React Component for getting confirmation to start a file recording session in
 * progress.
 *
 * @augments Component
 */
class StartRecordingDialog extends AbstractStartRecordingDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const {
            isTokenValid,
            isValidating,
            oneDriveSpaceLeft,
            oneDriveSpaceTotal,
            oneDriveSpaceUsed,
            oneDriveUserEmail,
            oneDriveUserName,
            selectedRecordingService,
            sharingEnabled,
            spaceLeft,
            userName,
            isLoaded,
            isAws
        } = this.state;
        const { _fileRecordingsServiceEnabled, _fileRecordingsServiceSharingEnabled, _isDropboxEnabled } = this.props;

        const storageType = this.state.recTypeData?.storage;
        const { s3_free_space = null, s3_used_space = null } = this.state?.recTypeData;
        const isStorageFull = this._isStorageFullForSelectedRecordingService();

        // disable ok button id recording service is shown only, when
        // validating dropbox token, if that is not enabled we either always
        // show the ok button or if just dropbox is enabled ok is available
        // when there is token
        const isOkDisabled
            = _fileRecordingsServiceEnabled && isLoaded ? isValidating
                : _isDropboxEnabled ? isTokenValid ? !isTokenValid : !isAws : false;
        const isSubmitDisabled = isOkDisabled || isStorageFull;

        return (
            <Dialog
                okDisabled = { isSubmitDisabled }
                okKey = 'dialog.startRecordingKey'
                onSubmit = { this._onSubmit }
                titleKey = 'dialog.startRecording'
                width = 'small'>
                <ErrorBoundary>
                    <>
                        {
                            this.state.isLoaded
                                ? <LoadingComponent src = { LOADING_INDICATOR } />
                                : <StartRecordingDialogContent
                                    fileRecordingsServiceEnabled = { _fileRecordingsServiceEnabled }
                                    fileRecordingsServiceSharingEnabled = { _fileRecordingsServiceSharingEnabled }
                                    integrationsEnabled = { this._areIntegrationsEnabled() }
                                    isAws = { isAws }
                                    isStorageFull = { isStorageFull }
                                    isTokenValid = { isTokenValid }
                                    isValidating = { isValidating }
                                    onChange = { this._onSelectedRecordingServiceChanged }
                                    onSharingSettingChanged = { this._onSharingSettingChanged }
                                    oneDriveSpaceLeft = { oneDriveSpaceLeft }
                                    oneDriveSpaceTotal = { oneDriveSpaceTotal }
                                    oneDriveSpaceUsed = { oneDriveSpaceUsed }
                                    oneDriveUserEmail = { oneDriveUserEmail }
                                    oneDriveUserName = { oneDriveUserName }
                                    selectedRecordingService = { selectedRecordingService }
                                    sharingSetting = { sharingEnabled }
                                    spaceLeft = { spaceLeft }
                                    storageSpace = {{ s3_free_space,
                                        s3_used_space }}
                                    storageType = { storageType }
                                    userName = { userName } />
                        }
                    </>
                </ErrorBoundary>
            </Dialog>
        );
    }

    _areIntegrationsEnabled: () => boolean;
    _onSubmit: () => boolean;
    _onSelectedRecordingServiceChanged: (string) => void;
    _onSharingSettingChanged: () => void;
}

export default translate(connect(mapStateToProps)(StartRecordingDialog));
